const initialState = {
    id: "0",
    descricao: "",
    valor: '0',
    url: '',
    obs: "",
    rq_add: "0",
    idgrupo: "0",
    tipo_partes: "0",
    id_tab_adicionais: "0",
    sabores: "",
    nomessabores: "",
    pizzas: [],
    nomespizzas: "",
    qtpizza: "0",
    qtde: "0",
    adicionais_app: "",    
    bordas_app: "",
    sabores_app: "",
    coberturas_app: ""
}

const ItemReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ITEM":
            return { ...state, 
                id:                action.payload.id, 
                descricao:         action.payload.descricao,
                valor:             action.payload.valor,
                url:               action.payload.url,
                obs:               action.payload.obs,
                rq_add:            action.payload.rq_add,
                idgrupo:           action.payload.idgrupo,
                tipo_partes:       action.payload.tipo_partes,
                id_tab_adicionais: action.payload.id_tab_adicionais,
                sabores:           action.payload.sabores,
                nomessabores:      action.payload.nomessabores,
                pizzas:            action.payload.pizzas,
                nomespizzas:       action.payload.nomespizzas, 
                qtpizza:           action.payload.qtpizza,
                qtde:              action.payload.qtde,
                adicionais_app:    action.payload.adicionais_app,
                bordas_app:        action.payload.bordas_app,
                sabores_app:       action.payload.sabores_app,
                coberturas_app:    action.payload.coberturas_app
             }
            break;
        default:
            break;
    }

    return state;
}

export default ItemReducer;